<form>
  <div class="ps-large-y">
    <h2 data-testid="entry-document-title">
      {{
        ((entryDocumentTitle$ | async) === EntryDocumentTitle.VISA
          ? 'MMB.apis.form.entryDocument.visaTitle'
          : 'MMB.apis.form.entryDocument.title'
        ) | finLocalization
      }}
    </h2>

    <fcom-notification class="ps-medium-t" [theme]="NotificationTheme.INFO">
      {{ 'MMB.apis.form.entryDocument.notification' | finLocalization }}
    </fcom-notification>
  </div>

  <div class="ps-small-b font-body-1 nordic-blue-900-text align-right">
    {{ 'MMB.apis.form.passport.mandatoryFields' | finLocalization }}
  </div>

  <div class="flex flex--wrap">
    <fin-select-input
      *ngIf="(requiredEntryDocumentType$ | async) === undefined"
      class="flex-1 input-field"
      [translationPrefix]="'MMB.apis.form.entryDocument.type'"
      [parentForm]="entryDocumentForm"
      [controlName]="'type'"
      [options]="entryDocumentTypes$ | async"
      [displayMargin]="false"
    >
    </fin-select-input>

    <fcom-text-input
      class="flex-1 input-field"
      data-testid="document-number"
      [translationPrefix]="'MMB.apis.form.entryDocument.number'"
      [parentForm]="entryDocumentForm"
      [controlName]="'number'"
      [displayMargin]="false"
    >
    </fcom-text-input>
  </div>

  <div class="flex flex--wrap">
    <fcom-text-input
      class="flex-1 input-field"
      data-testid="document-lastname"
      [translationPrefix]="'MMB.apis.form.entryDocument.lastName'"
      [parentForm]="entryDocumentForm"
      [controlName]="'lastName'"
      [displayMargin]="false"
    ></fcom-text-input>
    <fcom-text-input
      class="flex-1 input-field"
      data-testid="document-firstname"
      [translationPrefix]="'MMB.apis.form.entryDocument.firstName'"
      [parentForm]="entryDocumentForm"
      [controlName]="'firstName'"
      [displayMargin]="false"
    ></fcom-text-input>
  </div>

  <div class="flex flex--wrap">
    <fin-datepicker
      class="flex-1 input-field"
      data-testid="visa-birthdate"
      [translationPrefix]="'MMB.apis.form.passport.birthDate'"
      [parentForm]="entryDocumentForm"
      [controlName]="'birthDate'"
      [placeHolder]="'MMB.apis.form.passport.birthDate.placeholder'"
      [icon]="SvgLibraryIcon.CALENDAR"
      [minDate]="LocalDate.forDate(1900, 1, 1)"
      [theme]="DatepickerTheme.WEB_2"
      [displayMargin]="false"
      [startView]="'multi-year'"
      [startAt]="LocalDate.forDate(1980, 1, 1)"
    ></fin-datepicker>

    <fin-select-input
      class="flex-1 input-field"
      [translationPrefix]="'MMB.apis.form.gender'"
      [parentForm]="entryDocumentForm"
      [controlName]="'gender'"
      [options]="genders$ | async"
      [displayMargin]="false"
    >
    </fin-select-input>
  </div>

  <div class="flex flex--wrap" [class.ps-large-b]="!entryDocumentForm.controls.issuanceDate">
    <fin-datepicker
      class="flex-1 input-field"
      data-testid="visa-expirydate"
      [parentForm]="entryDocumentForm"
      [controlName]="'expiryDate'"
      [placeHolder]="'MMB.apis.form.entryDocument.expiryDate.placeholder'"
      [translationPrefix]="'MMB.apis.form.entryDocument.expiryDate'"
      [icon]="SvgLibraryIcon.CALENDAR"
      [theme]="DatepickerTheme.WEB_2"
      [minDate]="LocalDate.now()"
      [maxDate]="LocalDate.now().plusYears(20)"
      [displayMargin]="false"
      [startView]="'multi-year'"
      [startAt]="LocalDate.now().plusYears(5)"
    ></fin-datepicker>
    <fin-select-input
      class="flex-1 input-field"
      [controlName]="'issuingCountry'"
      [translationPrefix]="'MMB.apis.form.entryDocument.issuingCountry'"
      [parentForm]="entryDocumentForm"
      [options]="countries$ | async"
      [displayMargin]="false"
    >
    </fin-select-input>
  </div>

  <div
    *ngIf="entryDocumentForm.controls.issuanceDate || (showNationalitySelector$ | async) === true"
    class="flex flex--wrap ps-large-b"
  >
    <fin-datepicker
      *ngIf="entryDocumentForm.controls.issuanceDate"
      class="flex-1 input-field"
      data-testid="visa-issuancedate"
      [parentForm]="entryDocumentForm"
      [controlName]="'issuanceDate'"
      [placeHolder]="'MMB.apis.form.entryDocument.issuanceDate.placeholder'"
      [translationPrefix]="'MMB.apis.form.entryDocument.issuanceDate'"
      [icon]="SvgLibraryIcon.CALENDAR"
      [theme]="DatepickerTheme.WEB_2"
      [minDate]="LocalDate.now().minusYears(20)"
      [maxDate]="LocalDate.now()"
      [displayMargin]="false"
      [startView]="'multi-year'"
      [startAt]="LocalDate.now().minusYears(5)"
    ></fin-datepicker>
    <fin-select-input
      *ngIf="(showNationalitySelector$ | async) === true"
      class="flex-1 input-field"
      [translationPrefix]="'MMB.apis.form.entryDocument.nationality'"
      [parentForm]="entryDocumentForm"
      [controlName]="'nationality'"
      [options]="nationalities$ | async"
      [displayMargin]="false"
    >
    </fin-select-input>
    <div
      class="flex-1 input-field"
      *ngIf="!!entryDocumentForm.controls.issuanceDate !== (showNationalitySelector$ | async)"
    ></div>
  </div>

  <div role="presentation" class="border-top-dashed nordic-blue-100-border fill"></div>

  <div class="ps-large-y flex flex--end">
    <fcom-button
      [type]="ButtonType.SUBMIT"
      [loading]="loading"
      (clickBtn)="saveAndContinue()"
      [text]="'MMB.apis.form.buttons.confirmSave' | finLocalization"
    ></fcom-button>
  </div>
</form>
